// PrivacyPolicy.jsx
import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Switch, Select } from 'antd';
import { BreathAPIs } from '../../APIs/BreathAPIs';
import { toast } from 'react-toastify';
import { ButtonCustom } from '../../BootstrapComponents/ButtonCustom';

const EditCharger = ({ modalVisible, closeModal, selCharger, submitFeedback }) => {
    const handleCancel = () => {
        closeModal();
    };
    // console.log('selCharger', selCharger);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Add a state to store charger data
    const [chargerData, setChargerData] = useState({
        chargerTag: '',
        public: false,
        nonReservable: false,
        chargerAvailability: false,
        connector: [],
        connectionServer: '',
        chargerLevel:''
    });

    useEffect(() => {
        if (selCharger) {
            setChargerData(prevChargerData => ({
                ...prevChargerData,
                _id: selCharger?._id,
                chargerTag: selCharger?.chargerTag,
                chargerAvailability: selCharger?.chargerAvailability,
                unlistCharger: selCharger?.unlistCharger,
                connector: selCharger?.connector,
                public: selCharger?.public,
                nonReservable: selCharger?.nonReservable,
                connectionServer: selCharger?.connectionServer,
                chargerLevel:selCharger?.chargerLevel
            }));
        }
    }, [selCharger]);

    const { Option } = Select;
    const [form] = Form.useForm();

    const userSubmit = async () => {
        try {
            setIsSubmitting(true);
            const res = await BreathAPIs.updateCharger(chargerData);
            form.resetFields();
            submitFeedback(res?.data?.message);
            setIsSubmitting(false);
            closeModal();
        } catch (error) {
            toast.error('Error updating charger.');
            setIsSubmitting(false);
        }
    };

    return (
        <Modal
            title="Edit Charger"
            open={modalVisible}
            onCancel={handleCancel}
            footer={null}
            width={window.innerWidth <= 768 ? '100%' : '50%'}
        >
            <Form form={form} onFinish={userSubmit} layout={'vertical'} initialValues={chargerData}>

                <Form.Item label="Charger Tag">
                    <Input value={chargerData.chargerTag} onChange={(e) => setChargerData((prev) => ({ ...prev, chargerTag: e.target.value }))} />
                </Form.Item>

                
                <Form.Item label="Connection Server">
                    {/* <Input value={chargerData.connectionServer} onChange={(e) => setChargerData((prev) => ({ ...prev, connectionServer: e.target.value }))} /> */}
                    <Select value={chargerData?.connectionServer}   onChange={(value) => setChargerData(prev => ({ ...prev, connectionServer: value }))}   placeholder="Enter connection server">  
                    <Option value="CSMS_BREATHE">CSMS_BREATHE</Option>
                    <Option value="EDRV">EDRV</Option>
                </Select>
                </Form.Item>



                {chargerData?.connector?.map((connector, index) => (
                    <div key={connector.connectorNumber}>
                        <Form.Item label={`Connector-${connector.connectorNumber} - Power`} rules={[{ required: true, message: "Please input power" }]}>
                            <Input value={connector.power} type='number' onChange={e => {
                                const newConnectors = [...chargerData.connector];
                                newConnectors[index] = { ...newConnectors[index], power: e.target.value }; // Create a copy of the connector object
                                // newConnectors[index].power = e.target.value;
                                setChargerData(prev => ({ ...prev, connector: newConnectors }));
                            }} placeholder="11.1" />
                        </Form.Item>


                        <Form.Item label={`Connector-${connector.connectorNumber} - Non Reservable`} valuePropName="checked">
                            <Switch checked={connector.nonReservable} onChange={(checked) => {
                                const newConnectors = [...chargerData.connector];
                                newConnectors[index] = { ...newConnectors[index], nonReservable: checked }; // Create a copy of the connector object
                                // newConnectors[index].nonReservable = checked;
                                setChargerData(prev => ({ ...prev, connector: newConnectors }));
                            }} />
                        </Form.Item>


                        <Form.Item label={`Connector-${connector.connectorNumber} - Availability`} valuePropName="checked">
                            <Switch checked={connector.connectorAvailability} onChange={(checked) => {
                                const newConnectors = [...chargerData.connector];
                                newConnectors[index] = { ...newConnectors[index], connectorAvailability: checked }; // Create a copy of the connector object
                                // newConnectors[index].nonReservable = checked;
                                setChargerData(prev => ({ ...prev, connector: newConnectors }));
                            }} />
                        </Form.Item>


                    </div>
                ))}
                {/* <Form.Item label="Power"  rules={[{ required: true, message: "Please input power" }]}>
                    <Input value={chargerData?.connector?.power} type='number' onChange={e => setChargerData(prev => ({ ...prev, connector: { ...prev.connector, power: e.target.value } }))} placeholder="11.1" />
                </Form.Item> */}

                

                {/* <Form.Item label="Non Reservable"  valuePropName="checked">
                    <Switch checked={chargerData.nonReservable} onChange={(checked) => setChargerData((prev) => ({ ...prev, nonReservable: checked }))} />
                </Form.Item> */}




                <Form.Item label="Public"  valuePropName="checked">
                    <Switch disabled={true} checked={chargerData.public} onChange={(checked) => setChargerData((prev) => ({ ...prev, public: checked }))} />
                </Form.Item>

                <Form.Item label="Charger Availability"  valuePropName="checked">
                    <Switch checked={chargerData.chargerAvailability} onChange={(checked) => setChargerData((prev) => ({ ...prev, chargerAvailability: checked, unlistCharger: false }))} />
                </Form.Item>

                <Form.Item label="Admin Control (Availability)"  valuePropName="checked">
                    <Switch checked={chargerData.unlistCharger} onChange={(checked) => setChargerData((prev) => ({ ...prev, unlistCharger: checked }))} />
                </Form.Item>
                <div>
                    <h5>Charger Level : {chargerData.chargerLevel}</h5>
                </div>





                <div className="col-md-12">
                    <Form.Item style={{ textAlign: 'right' }}>
                        <ButtonCustom isLoading={isSubmitting} text={isSubmitting ? 'Updating...' : 'Update Charger'} type="submit" />
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    );
};

export default EditCharger;
